import React, { createRef } from 'react';
import cn from 'classnames';
import { withRouter } from 'next/router';
import { BodyCellPure } from '@creditflowresearch/uilib/Table/DataTable/Body/BodyCell';
import { SectorCell, BondNameCell, StatusCell } from '@/creditflowresearch/ui/common/components/TableCells';
import { useFiltersContext } from '@/creditflowresearch/application/FiltersContext';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';
import {
  getCeCell,
  getCurrentFaceCell,
  getDealerCell,
  getDueByCell,
  getIdentifierCell,
  getListIdCell,
  getOriginalFaceCell,
  getOtherRatingCell,
  getPriceTalkCell,
  getRatingCell,
  getSpeedCell,
  getSpreadCell,
  getWalCell,
} from '../../cellCallbacks';

import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';
import styles from '@/creditflowresearch/ui/components/bonds/common/BondTables/bondsTables.module.scss';

const BwicRow = (props) => {
  const { row } = props;
  const rowRef = createRef<React.LegacyRef<HTMLElement> | null>();
  const { onSearch } = useFiltersContext();
  const { timeZone } = useUserTimeZoneContext();

  const handleMouseEnter = () => {
    const node = rowRef.current;

    if (node) {
      // @ts-ignore
      node.querySelector('.togglerCheckbox').checked = false;
    }
  };

  return (
    <tr
      // @ts-ignore
      ref={ rowRef }
      onMouseEnter={ handleMouseEnter }
      className={ styles.row }
    >
      <BodyCellPure
        name="status"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ StatusCell }
      />
      <BodyCellPure
        name="sector"
        className={ alignStyles.alignLeft }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ SectorCell }
      />
      <BodyCellPure
        name="name"
        className={ alignStyles.alignLeft }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ BondNameCell }
      />
      <BodyCellPure
        name="originalFace"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getOriginalFaceCell }
      />
      <BodyCellPure
        name="currentFace"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getCurrentFaceCell }
      />
      <BodyCellPure
        name="wal"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getWalCell }
      />
      <BodyCellPure
        name="ratingMoodys"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingSAndP"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingFitch"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingDBRS"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingKroll"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingOtherOrUnspecified"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getOtherRatingCell }
      />
      <BodyCellPure
        name="spread"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getSpreadCell }
      />
      <BodyCellPure
        name="speed"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getSpeedCell }
      />
      <BodyCellPure
        name="ce"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getCeCell }
      />
      <BodyCellPure
        name="priceTalk"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getPriceTalkCell }
      />
      <BodyCellPure
        name="dealer"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getDealerCell }
      />
      <BodyCellPure
        name="listId"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={
          (cellProps) => getListIdCell(cellProps, onSearch)
        }
      />
      <BodyCellPure
        name="identifier"
        className={
          cn(styles.identifierCell, alignStyles.alignRight, spacesStyles.ptn, spacesStyles.pbn, spacesStyles.prl)
        }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getIdentifierCell }
      />
      <BodyCellPure
        name="dueBy"
        className={ cn(styles.dueByCell, alignStyles.alignRight) }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ (cellProps) => getDueByCell(cellProps, timeZone) }
      />
    </tr>
  );
};

export default withRouter(BwicRow);
